import toSlug from '~/lib/to-slug'
import formatString from '~/lib/formatString'

import strings from '../strings.json'

export function getRelatedItemsContent(content, parentPath) {
  const localeStrings = strings[content.locale]
  if (localeStrings && content.relatedResourceLinks) {
    const { heading, viewMoreText } = localeStrings.relatedItemsByType[content._type]
    if (content.relatedResourceLinks.length > 0) {
      return {
        heading,
        resourceLinks: content.relatedResourceLinks,
        viewMoreLink: {
          text: viewMoreText,
          path: parentPath,
        },
      }
    }
  }
}

export function getResourceArticlePath(content, articlePathPattern) {

  if (content.isExternalArticle || content.isLinkToInternalPage) {
    return content.url
  }

  return formatString(articlePathPattern, content)
}

export function getCategoryRelatedItemsContent(content, parentPath) {
  const localeStrings = strings[content.locale]
  if (localeStrings && content.categoryRelatedResourceLinks) {
    if (content.categoryRelatedResourceLinks.length === 4) {
      const { heading, viewMoreText } = localeStrings.relatedItemsByCategory
      return {
        heading,
        resourceLinks: content.categoryRelatedResourceLinks,
        viewMoreLink: {
          text: viewMoreText.replace('{category}', content.category.title),
          path: `${parentPath}?category=${content.category.slug.current}`,
        },
      }
    }
  }
  // Fall back to non-category related items content
  return getRelatedItemsContent(content, parentPath)
}

export function genIdsForHeadings(blocks) {
  const result = {}
  if (blocks) {
    blocks.forEach(function ({ _key, children, style }) {
      if (style === 'h2') {
        const text = children.map(({ text }) => text).join(' ')
        result[_key] = toSlug(text)
      }
    })
  }
  return result
}
